import { Evidence } from "@p0security/shared/types/evidence";
import { RequestNotifications } from "@p0security/shared/types/permission";
import { Flex, Typography } from "antd";
import { formatDistanceStrict } from "date-fns";

import { renderPreApproval } from "../requestRenderUtils";
import { NotifierConversationLinks } from "./ConversationLink";

export const RequestHistoryRequestedApprovedBy: React.FC<{
  notifications?: RequestNotifications;
  timestamp?: number;
  username?: string;
  preApproval?: readonly [Evidence["source"], string] | "unknown";
}> = ({ notifications, timestamp, username, preApproval }) => {
  return username ? (
    <Flex vertical>
      <Typography.Text ellipsis>{username}</Typography.Text>
      {timestamp && (
        <Flex align="center" justify="flex-start" gap={6}>
          <NotifierConversationLinks notifications={notifications} />
          <Typography.Text className="sub-text" ellipsis type="secondary">
            {formatDistanceStrict(timestamp, Date.now(), {
              addSuffix: true,
            })}
          </Typography.Text>
        </Flex>
      )}
      {preApproval && (
        <Typography.Text className="sub-text" type="secondary">
          {renderPreApproval(preApproval, true)}
        </Typography.Text>
      )}
    </Flex>
  ) : null;
};
